import {
  afterNextRender,
  booleanAttribute,
  Directive,
  ElementRef,
  inject,
  input,
} from '@angular/core';

@Directive({
  selector: '[fcFocusOnAppear]',
  standalone: false,
})
export class FocusOnAppearDirective {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly focusOnAppear = input(true, {
    alias: 'fcFocusOnAppear',
    transform: booleanAttribute,
  });

  constructor() {
    afterNextRender(() => {
      if (this.focusOnAppear()) this.elementRef.nativeElement.focus();
    });
  }
}
